import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "lp_admin_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const COLLECTION_KEYS = ["results", "races", "news", "gallery", "sponsors"];

export async function fetchSiteData() {
  const settled = await Promise.allSettled(COLLECTION_KEYS.map((k) => api.get(`/${k}`)));
  return COLLECTION_KEYS.reduce((acc, key, i) => {
    const r = settled[i];
    acc[key] = r.status === "fulfilled" && Array.isArray(r.value?.data) ? r.value.data : [];
    return acc;
  }, {});
}
